export default [
    {
        path: "",
        name: "login",
        component: () =>
            import(/*webpackChunkName: "home"*/ "../pages/auth/LoginView.vue"),
        meta: {
            title: "Log In",
        },
    },
    {
        path: "/reset-password",
        name: "reset-password",
        component: () =>
            import(
                /*webpackChunkName: "home"*/ "../pages/auth/ResetPasswordView.vue"
            ),
        meta: {
            title: "Reset Password",
        },
    },
    {
        path: "/pagenotfound",
        name: "pagesnotfound",
        component: () => import("../components/common/404NotFound.vue"),
        meta: {
            title: "Page not found",
        },
    },
];
